import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const CHANGE_PRIMARY_ADDRESS_REQUEST = 'CHANGE_PRIMARY_ADDRESS_REQUEST';
export const CHANGE_PRIMARY_ADDRESS_SUCCESS = 'CHANGE_PRIMARY_ADDRESS_SUCCESS';
export const CHANGE_PRIMARY_ADDRESS_FAILURE = 'CHANGE_PRIMARY_ADDRESS_FAILURE';

function request() {
  return {
    type: CHANGE_PRIMARY_ADDRESS_REQUEST,
  };
}

function receive(data) {
  return {
    type: CHANGE_PRIMARY_ADDRESS_SUCCESS,
    addresses: data
  };
}

function reject() {
  return {
    type: CHANGE_PRIMARY_ADDRESS_FAILURE,
  };
}

export function changePrimaryAddress(customerId, addressId) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .changePrimaryAddress(customerId, addressId)
      .then((response) => {
        dispatch(receive(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true));
        }
      });
    return promise();
  };
}
